import { render } from "./Main-page.vue?vue&type=template&id=d0f9f3f0"
import script from "./Main-page.vue?vue&type=script&lang=js"
export * from "./Main-page.vue?vue&type=script&lang=js"

import exportComponent from "/Users/thomas/Desktop/CNT/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__